const isVideoUrl = (url: string): boolean => {
  const indextype = url.split('.').length - 1;
  const assetType = url.split('.')[indextype].toUpperCase();
  return ['WEBM', 'MPG', 'MPEG', 'MPE', 'MP4', 'M4P', 'M4V', 'AVI', 'WMV', 'MOV'].includes(assetType) || url.includes('youtube') || url.includes('youtu.be');
};
export default isVideoUrl;